export var createMuiListItemTextOverrides = function (_a) {
    var typography = _a.typography;
    return {
        styleOverrides: {
            primary: {
                fontSize: typography.pxToRem(14),
                fontWeight: typography.fontWeightBold,
            },
            secondary: {
                fontSize: typography.pxToRem(13),
            },
        },
    };
};
